import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';
import medicalDataParser from 'utils/medicalDataParser';

function getPatientHl7Data() {
  return Storages.MainStorage.getItem(StorageKeys.Keys.PATIENT_HL7_DATA) ?? {};
}

function getPatientReferenceId() {
  const customerData = Storages.MainStorage.getItem(StorageKeys.Keys.CUSTOMERDATA) ?? {};
  return customerData.reference_id || '';
}

function isPatientCheckedIn() {
  return !!getPatientReferenceId();
}

/**
 * Extract a single field from stored HL7 data using the medical data parser.
 */
function getPatientField(objName, key, patientData) {
  const data = patientData || getPatientHl7Data();
  return medicalDataParser.getPatientData(data, objName, key);
}

function getGuestName(patientData) {
  const data = patientData || getPatientHl7Data();
  const givenName = getPatientField('pid_patient_name', 'given_name', data);
  const familyName = getPatientField('pid_patient_name', 'family_name', data);
  return `${givenName} ${familyName}`.trim();
}

function hasGuestName(patientData) {
  return !!getGuestName(patientData);
}

/**
 * Check-in metadata plus parser-derived display fields for UI consumers.
 */
function getCustomerDisplayData() {
  const customerData = Storages.MainStorage.getItem(StorageKeys.Keys.CUSTOMERDATA) ?? {};
  return {
    reference_id: customerData.reference_id || '',
    guest_name: getGuestName(),
  };
}

const patientData = {
  getPatientHl7Data,
  getPatientReferenceId,
  isPatientCheckedIn,
  getPatientField,
  getGuestName,
  hasGuestName,
  getCustomerDisplayData,
};

export default patientData;
